import React, {Component} from 'react'
import {connect} from 'react-redux'

import { getDifferenceInCalendarDays } from '../../actions/dateUtility';

import {getNotifications} from '../../services/reservoir'
import Loading from '../tags/Loading'

const mapStateToProps = ({
                           courses: { selectedCourseCode, data }, course: { selectedCourse },
                         }) => {
  return {
    admissionCategory: selectedCourse.admissionCategory,
    college: selectedCourse.orgUnit,
  }
}

class Notifications extends Component {
  constructor (props) {
    super(props)

    this.state = {
      notifications: [],
      loadingNotifications: true,
    }
  }

  componentDidMount() {
    getNotifications(this.props.admissionCategory, this.props.college).then(notifications => {
      this.setState({
        notifications: notifications,
        loadingNotifications: false,
      })
    })
  }

  getTimestampMessage = days => {
    switch (days) {
      case 0:
        return 'Today'
      case 1:
        return `${days} day ago`
      default:
        return `${days} days ago`
    }
  }

  render() {
    return (
      <div className="page">
        <div className="row">
          <div className="col-xs-12 col-md-offset-2 col-md-8">
            {this.state.loadingNotifications ? (
              <section className='tile-container'>
                <Loading message="Loading your notifications..."/>
              </section>
            ) : (
              <div>
                {this.state.notifications.length > 0 ? this.state.notifications.map(notification => {
                  const notificationAttributes = notification.attributes
                  const days = getDifferenceInCalendarDays(new Date(), new Date(notificationAttributes.created * 1000))

                  return (
                    <div className="notification-container">
                      <h2>{notificationAttributes.title}</h2>
                      <p className="notification-content">{notificationAttributes.field_description1}</p>
                      {/*<p className="date-stamp">{this.getTimestampMessage(days)}</p>*/}
                    </div>
                  )
                }) : (
                  <div className="col-xs-12">
                    <div className="empty-state-container empty-state-container--notifications">

                        <div className="icon"/>
                        <h2>You don't have any notifications</h2>

                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(Notifications)
